export const mediaPattern = /(<(img\s)([\w\W]+?)>)|((<iframe.+src=".+)\/iframe>)|((<iframe.+src="https:\/\/flickrembed.+)>([\w\W]+?)<\/script>)/gim
export const splitPattern = '||||||' // unique split pattern for devicing array
export const labelPattern = /<span.*class=.tiptext.*.*?<\/span>/gi
export const titlePattern = /(?:<strong>)(.*?)(?=<\/strong>)/gi; // /(?<=<strong>)(.*?)(?=<\/strong>)/gi

// /(?<=\/)([^#]+)(?=#*)/
// /(?:\/)([^#]+)(?=#*)/

export const removePatterns = [
    /<font.+?>/gi,
    /<\/font>/gi,
    /<span.+?>/gi,
    /<\/span>/gi,
    /<p?>/gi,
    /<\/p>/gi,
    /<br.\/>/gimu,
    /<br>/gimu,
    /<span>/gi
  ]
export const imagePattern = /(?:src=")(.*?)(?=")/gi;// /(?<=src=")(.*?)(?=")/gi;
export const altPattern = /(?:alt=")(.*?)(?=")/gi;// /(?<=alt=")(.*?)(?=")/gi;
export const tablePattern = /<table.+>([\s\S]*?)<\/table>/gim
export const noEmptyPattern = /<td+>\w+<\/td>/gim
export const flickrPattern =/(?:input=)\w+/g;// /(?<=input=)\w+/g
function urlTransformer(url:string) {
  return url
}

function classIdTransformer(name:string) {
  return name
}
export const Sanitize = (html:string) => {

  //if (html_sanitize!=null) {
    //html_sanitize(html, urlTransformer, classIdTransformer);
  //}
  return html;

}
